import { Carousel as CarouselOriginal, Slide } from 'vue-carousel'

const Carousel = {
  name: 'Carousel',
  extends: CarouselOriginal,
  methods: {
    goToPage(page, advanceType) {
      //TODO: B2C-2668 Get back to original vue-carousel after bug fix got merged.
      // Original code: if (page >= 0 && page <= this.pageCount) {
      if (page >= 0 && page <= this.slideCount) {
        this.offset = this.scrollPerPage
          ? Math.min(this.slideWidth * this.currentPerPage * page, this.maxOffset)
          : this.slideWidth * page

        // restart autoplay if specified
        if (this.autoplay && !this.autoplayHoverPause) {
          this.restartAutoplay()
        }

        // update the current page
        this.currentPage = page

        if (advanceType === 'pagination') {
          this.pauseAutoplay()
          this.$emit('pagination-click', page)
        }
      }
    },
  },
}
export { Carousel, Slide }
